const CloudArrowUpIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33203 4C7.67518 4 6.33203 5.34315 6.33203 7C6.33203 7.27614 6.10817 7.5 5.83203 7.5H5.58203C4.33939 7.5 3.33203 8.50736 3.33203 9.75C3.33203 10.9926 4.33939 12 5.58203 12H6.35445C6.3854 12.3434 6.44791 12.6777 6.53906 13H5.58203C3.78711 13 2.33203 11.5449 2.33203 9.75C2.33203 8.029 3.66972 6.62043 5.36207 6.50733C5.60486 4.53062 7.2897 3 9.33203 3C11.2616 3 12.8721 4.36628 13.2488 6.1842C12.8999 6.09145 12.5373 6.03214 12.1648 6.0099C11.7558 4.83954 10.6419 4 9.33203 4ZM16.332 11.5C16.332 13.9853 14.3173 16 11.832 16C9.34675 16 7.33203 13.9853 7.33203 11.5C7.33203 9.01472 9.34675 7 11.832 7C14.3173 7 16.332 9.01472 16.332 11.5ZM11.4781 9.14684L9.47848 11.1464C9.28322 11.3417 9.28322 11.6583 9.47848 11.8536C9.67374 12.0488 9.99032 12.0488 10.1856 11.8536L11.332 10.7071V13.5C11.332 13.7761 11.5559 14 11.832 14C12.1082 14 12.332 13.7761 12.332 13.5V10.7071L13.4785 11.8536C13.6737 12.0488 13.9903 12.0488 14.1856 11.8536C14.3808 11.6583 14.3808 11.3417 14.1856 11.1464L12.1856 9.14645C12.1376 9.09851 12.0824 9.06234 12.0234 9.03794C11.9653 9.01385 11.9017 9.0004 11.835 9.00001L11.832 9L11.829 9.00001C11.7623 9.0004 11.6987 9.01385 11.6406 9.03794C11.5825 9.06198 11.528 9.09744 11.4806 9.14433L11.4781 9.14684Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CloudArrowUpIcon;
